import React, { useState } from 'react';
import SearchIcon from '@tradera/blueprint/theme/icons2/search.svg?jsx';

const InternalSearchForm = ({ internalSearch, handleInternalSearch }) => {
    const [searchString, setSearchString] = useState('');
    const { placeholder } = internalSearch;
    return (
        <div className="form-control-with-icon mx-2 mx-md-0">
            <form
                onSubmit={e => {
                    e.preventDefault();
                    handleInternalSearch(searchString);
                }}>
                <input
                    type="text"
                    className="form-control mt-1 my-md-3"
                    placeholder={placeholder || 'Sök'}
                    value={searchString}
                    onChange={e => setSearchString(e.target.value)}
                />
            </form>
            <SearchIcon className="icon icon-dark mr-2" />
        </div>
    );
};

export default InternalSearchForm;
